export default "__VITE_ASSET__5883c390__"